// @flow

import React, { type Node } from 'react';
import { getWeekDay } from '@tectonics/prs/week-day';
import {
  InformationBoxArea,
  RenderButtonArea,
  RenderPaymentInstructions,
} from './spei-page-components';
import { EmailVoucherMessage } from '../commons/email-voucher-message';
import { VoucherNumberBox } from '../commons/voucher-number-box';
import {Separator} from '../../../atoms';
import { DisplayDueDate } from '../../../organisms/display-due-date';
import {
  PaymentInfoWrapper,
  DashedHr, Content,
} from '../../../organisms/shared-styled-components';
import { RenderPaymentInfoContainer } from '../../../organisms/payment-info-display';
import {
  getDestinyBank,
  getSafeClabeAccount,
  getSafeClabeReference, getSafeDueDate,
  usePendingIncomingPayment,
} from '../../../../../prs/incoming-payment';
import styled from 'styled-components';
import {MerchantInfo} from '../voucher-page/merchant-info';
import {MobileTotalAmount} from '../../../organisms/mobile-total-amount';
import {MerchantLogo} from '../../../organisms/merchant-info';
import {DisplayTotalAmount} from '../../../organisms/display-total-amount.js';


export function SpeiPage(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const clabeAccount = getSafeClabeAccount(incomingPayment);
  const clabelReference = getSafeClabeReference(incomingPayment);
  const destinyBank = getDestinyBank(incomingPayment);
  return (
    <Content>
    <>
      <MerchantLogo height="100px" />
      <MobileTotalAmount />
      <EmailVoucherMessage
        headerMessage="Boleta generada!"
        textBeforeEmailAddress="Una copia de su número de la boleta fue enviada a"
        textAfterEmailAddress=", sin embargo, ya puedes pagar tu compra con los siguientes datos:"
      />
      <PaymentInfoWrapper>
        <DisplayTotalAmount label="Valor a pagar" redesign={true} location="left"  />
        <DisplayDueDate label="Fecha de Vencimiento" sublabel={`Pagar hasta el ${getWeekDay(getSafeDueDate(incomingPayment), dueDateWeekDay)}`} redesign={true}   />
        <VoucherNumberBox>
          <InformationBoxArea value={clabeAccount} text={'CLABE interbancaria'}> </InformationBoxArea>
          <InformationBoxArea value={clabelReference} text={'Número de referencia:'}> </InformationBoxArea>
          <InformationBoxArea value={destinyBank} text={'Banco destino:'}> </InformationBoxArea>
          <InformationBoxArea value={'EBANX'} text={'Beneficiario:'} lastItem={true}> </InformationBoxArea>

        </VoucherNumberBox>
      </PaymentInfoWrapper>


      <Separator direction="vertical" size={3} />

      <RenderButtonArea />

      <DashedHr />

      <TittleInstructions>Instrucciones de pago</TittleInstructions>

      <RenderPaymentInstructions />

      <DashedHr />

      <RenderPaymentInfoContainer
        h1Text="¿Ya conoces la Central de Ayuda EBANX?"
        items={[
          {
            imgSrc: 'https://cdn.ebanx.com/images/vouchers/files-icon.svg',
            subText: 'Si tienes dudas adicionales acerca de tu pago, o tu reembolso visítanos en la Central de Ayuda EBANX:',
            strong:  'ayuda.ebanx.com/hc/es-mx',
          },
        ]}
      />
    </>
    <MerchantInfo> </MerchantInfo>
    </Content>
  );
}

const dueDateWeekDay = [
  'lunes',
  'lunes',
  'martes',
  'miércoles',
  'jueves',
  'viernes',
  'lunes',
];
const TittleInstructions = styled.p`
  font-family: Gilroy, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
 `;
